'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = require('./utils.js');

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Polyglot = require('node-polyglot');

function getDefaults() {
  return {};
}

var PolyglotFormat = function () {
  function PolyglotFormat(options) {
    _classCallCheck(this, PolyglotFormat);

    this.type = 'i18nFormat';

    this.init(null, options);
  }

  _createClass(PolyglotFormat, [{
    key: 'init',
    value: function init(i18next, options) {
      var i18nextOptions = i18next && i18next.options && i18next.options.i18nFormat || {};
      this.options = utils.defaults(i18nextOptions, options, this.options || {}, getDefaults());

      // expose
      if (i18next) i18next.Polyglot = Polyglot;
    }
  }, {
    key: 'parse',
    value: function parse(res, options, lng, ns, key) {
      return Polyglot.transformPhrase(res, options, lng);
    }
  }, {
    key: 'addLookupKeys',
    value: function addLookupKeys(finalKeys, key, code, ns, options) {
      // no additional keys needed for select or plural
      // so there is no need to add keys to that finalKeys array
      return finalKeys;
    }
  }]);

  return PolyglotFormat;
}();

PolyglotFormat.type = 'i18nFormat';

exports.default = PolyglotFormat;